@if (showToggleAll && groupedIssues.length > 0) {
  <div class="toggle-all-row">
    <a class="toggle-all-btn" href="javascript:void(0)" role="button" (click)="toggleAll()">
      <i class="fa-sharp fa-regular" [ngClass]="allExpanded ? 'fa-angles-up' : 'fa-angles-down'"></i>
      {{ allExpanded ? 'Collapse All' : 'Expand All' }}
    </a>
  </div>
}
@for (group of groupedIssues; track trackByGroup($index, group)) {
  <div class="issue-group">
    <!-- Single-issue group: render as content group (no parent accordion needed) -->
    @if (group.issues.length === 1) {
      <issue-content-group
        [subGroup]="group.contentSubGroups[0]"
        [sync-pair]="syncPair"
        [application]="application"
        (resourceClicked)="resourceClicked.emit($event)"
      ></issue-content-group>
    } @else {
      <button class="group-header" (click)="toggleGroup(group)" [class.expanded]="group.expanded">
        <div class="group-title">
          <span class="group-name">{{ group.displayName }}</span>
          <span class="group-count">{{ group.issues.length }}</span>
        </div>
        <div class="group-end">
          @if (group.resourceTypesLabel) {
            <span class="group-resource-types">{{ group.resourceTypesLabel }}</span>
          }
          <i
            class="group-chevron fa-utility fa-semibold"
            [ngClass]="{ 'fa-angle-down': !group.expanded, 'fa-angle-up': group.expanded }"
          ></i>
        </div>
      </button>
      <div class="group-body" [@accordionSlide]="group.expanded ? 'expanded' : 'collapsed'">
        @for (subGroup of group.contentSubGroups; track trackBySubGroup($index, subGroup)) {
          <issue-content-group
            [subGroup]="subGroup"
            [sync-pair]="syncPair"
            [application]="application"
            [flat]="group.contentSubGroups.length === 1"
            [grouped]="true"
            (resourceClicked)="resourceClicked.emit($event)"
          ></issue-content-group>
        }
      </div>
    }
    <!-- Multi-issue group: parent accordion with children -->
  </div>
}
